// extracted by mini-css-extract-plugin
export default {"container":"Main_container__sY-GI","title":"Main_title__ZpcYP","subtitle":"Main_subtitle__Wo2Ll","cards":"Main_cards__ZoHfL","card":"Main_card__dnZuo","info":"Main_info__ApCOB"};